// @purpose GLUE
// Disclosure menus (`<details data-menu>`, the header account menu): a native <details> opens and closes
// without JS; this adds what a menu needs on top. A tap outside, Escape (focus back on the button) or
// following one of its links closes it. Delegated on document, so boosted page swaps need no re-binding.

function openMenus() {
  return document.querySelectorAll("details[data-menu][open]");
}

export function initMenus() {
  document.addEventListener("click", (e) => {
    for (const menu of openMenus()) {
      if (!menu.contains(e.target) || e.target.closest("a")) menu.open = false;
    }
  });
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    for (const menu of openMenus()) {
      menu.open = false;
      menu.querySelector("summary")?.focus();
    }
  });
}
